import {
  compose,
  defaultProps,
  withHandlers,
  withPropsOnChange,
  withState,
} from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { commonServicesProvider } from '../../services/hoc';
import { getAllowMultipleServices } from '../../barbers/selectors';
import { fetchServices } from '../../services/actions';
import {
  generateUrlString,
  toggleItemInArray,
} from '../../utils/helpers';
import Services from './components/Services';


const fetchData = compose(
  withRouter,
  connect(null, { fetchServices }),
  withHandlers({
    fetchData: props => () =>
      props.fetchServices(props.params.shopRoute, props.params.barberRoute, props.params, props.urlPattern),
  }),
);

const fetchDataOnBarberChange = withPropsOnChange(
  (props, nextProps) => props.params.barberRoute !== nextProps.params.barberRoute,
  (props) => {
    props.fetchData();
  }
);

const generateUrl = compose(
  withRouter,
  connect((state, ownProps) => ({
    allowMultipleServices: getAllowMultipleServices(state, ownProps.params.barberRoute, ownProps.params.shopRoute),
  })),
  withHandlers({
    generateUrlString: props => params => generateUrlString({
      ...props.params,
      ...params,
    }, props.urlPattern),
  }),
  withState('selectedIds', 'setSelectedService', ''),
  withState('nextLink', 'setNextLink', ''),
  withHandlers({
    onServiceClick: props => id => () => {
      const serviceId = (() => {
        if (!props.allowMultipleServices) return id;
        if (!props.selectedIds) return id;

        return toggleItemInArray(props.selectedIds.split(';'), id).join(';');
      })();

      props.setSelectedService(() => serviceId);
      props.setNextLink(() => props.generateUrlString({ serviceId }));
    },
  })
);

export default compose(
  fetchData,
  fetchDataOnBarberChange,
  generateUrl,
  commonServicesProvider,
  defaultProps({
    autoHeight: true,
  }),
)(Services);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/Services.js